import React from 'react';
import styled, { css } from 'styled-components/macro';
import { FiAlertTriangle, FiRefreshCcw, FiHome } from 'react-icons/fi';



const AlertTriangle = () => {
    return <FiAlertTriangle
        aria-hidden="true"
        color="white"
        css={css`
            width: 25px;
            height: 25px;
        `}
    />
}


const ErrorPage = () => {

    function refreshPage() {
        window.location.reload(false);
    }

    return (
        <>
            <ErrorContainer>
                <TextErrorContainer>
                    <AlertTriangle />
                    <TextError>
                        Ha ocurrido un error al hacer la solicitud
                    </TextError>
                    <AlertTriangle />

                </TextErrorContainer>
                <Separator />
                <Buttons>
                    <Links href='/inicio'>Ir a inicio<FiHome
                        aria-hidden="true"
                        css={css`
                        width: 20px;
                        height: 20px;
                      `}
                    />
                    </Links>
                    <Links href='' onClick={refreshPage}>Refrescar
                        <FiRefreshCcw
                            aria-hidden="true"
                            css={css`
                        width: 20px;
                        height: 20px;
                      `}
                        /></Links>
                </Buttons>
            </ErrorContainer>
        </>
    );
};

const ErrorContainer = styled.div`
  height:100vh;
  display:flex;
  gap:1rem;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  line-height: normal;
  max-width: 1366px;
  margin:auto;
  color:#164192;
`;

const TextErrorContainer = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  gap:2rem;
`;

const TextError = styled.div`
    font-size: 32px;
    font-weight: 500;

    @media (max-width: 768px) {
        font-size: 20px;
    }
`;


const Separator = styled.div`
  width:70%;
  height:1px;
  background: #164192;
`;

const Buttons = styled.div`
  display:flex;
  gap:1rem;
  margin-top:1rem;
`;

const Links = styled.a`
    display: flex;
    gap:1rem;
    padding: 20px 40px;
    justify-content: flex-center;
    align-items: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-radius: 3px;
    background: #164192;
    border:2px solid #164192;
    border-radius: 25px;
    color:white;

    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
    }

    &:hover {
        color:#164192;
        background: transparent;
    }
`


export default ErrorPage;
